document.addEventListener("DOMContentLoaded", function() {
  const factsAccordionSections = document.querySelectorAll('.js-accordion-facts-section');
  
  factsAccordionSections.forEach(section => {
    const isMobile = window.innerWidth <= 1024;
    const accordions = section.querySelectorAll('.js-accordion-facts-item');
    const descriptions = section.querySelectorAll('.js-accordion-facts-description');
    
    // Function to activate an accordion item
    const activateAccordion = (accordion) => {
      // Remove active class from all accordions and descriptions
      accordions.forEach(acc => acc.classList.remove('--is-active'));
      descriptions.forEach(desc => desc.classList.remove('--is-active'));
      
      // Add active class to current accordion
      accordion.classList.add('--is-active');
      
      // Find matching description and activate it
      const accordionId = accordion.getAttribute('data-accordion-item');
      const description = Array.from(descriptions).find(
        desc => desc.getAttribute('data-accordion-item') === accordionId
      );
      
      if (description) {
        description.classList.add('--is-active');
      }
    };

    // By default, activate first accordion if not mobile
    if (!isMobile && accordions.length > 0) {
      activateAccordion(accordions[0]);
    }
    
    // Set up event listeners based on device type
    accordions.forEach(accordion => {
      // For mobile - use click events and scroll to content
      accordion.addEventListener('click', () => {
        activateAccordion(accordion);
        
        // On mobile, scroll to the activated accordion
        if (window.innerWidth <= 1024) {
          setTimeout(() => {
            const top = accordion.getBoundingClientRect().top;
            window.scrollTo({
              top: top + window.scrollY - 100,
              behavior: 'smooth'
            });
          }, 350);
        }
      });
      
      // For desktop - also use hover events
      if (!isMobile) {
        accordion.addEventListener('mouseenter', () => {
          activateAccordion(accordion);
        });
      }
    });
  });
  
  // Handle window resize events
  window.addEventListener('resize', function() {
    const isMobile = window.innerWidth <= 1024;
    const accordions = document.querySelectorAll('.js-accordion-facts-item');
    
    if (isMobile) {
      // On mobile, deactivate all accordions
      accordions.forEach(acc => acc.classList.remove('--is-active'));
      document.querySelectorAll('.js-accordion-facts-description').forEach(desc => {
        desc.classList.remove('--is-active');
      });
    } else if (accordions.length > 0) {
      // On desktop, activate the first accordion by default
      const firstAccordion = accordions[0];
      if (firstAccordion) {
        firstAccordion.classList.add('--is-active');
        
        const firstAccordionId = firstAccordion.getAttribute('data-accordion-item');
        const firstDescription = document.querySelector(`.js-accordion-facts-description[data-accordion-item="${firstAccordionId}"]`);
        
        if (firstDescription) {
          firstDescription.classList.add('--is-active');
        }
      }
    }
  });
});